import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import LoaderComponent from '@components/atom/layout/loader';
import FadeLoader from 'react-spinners/FadeLoader';

const GridAtom = ({ columns, data, height }) => {
  return (
    <DataTable
      columns={columns}
      data={data}
      pagination
      // progressPending={!data && !columns}
      progressPending={!columns}
      progressComponent={
        <LoaderComponent height={height}>
          <FadeLoader />
        </LoaderComponent>
      }
    />
  );
};

export default GridAtom;
